import React, {
  useState,
} from 'react';

import * as S from './styled';

type Props = {
  body?: React.ReactNode;
  place?: string;
  theme?: string;
  width?: string;
  isOpen?: boolean;
  children?: React.ReactNode;
  preferPlace?: string | null;
  initialState?: boolean;
  toggleMode?: boolean;
};

const Tooltip = ({
  body,
  place,
  theme,
  width,
  isOpen,
  children,
  preferPlace,
  initialState,
  toggleMode,
}: Props) => {
  const [isOpenState, setIsOpen] = useState(initialState);

  const triggerProps = toggleMode ? {
    onClick: (event: Event) => {
      setIsOpen(!isOpenState);
      if (children?.props.onClick) {
        children.props.onClick(event);
      }
    },
  } : {
    onMouseOver: () => setIsOpen(true),
    onMouseOut: () => setIsOpen(false),
  };

  return (
    <S.StyledPopover
      isOpen={typeof isOpen !== 'undefined' ? isOpen : isOpenState}
      refreshIntervalMs={false}
      body={(
        <S.Body
          theme={theme}
          width={width}
        >
          <p
            style={{ margin: '0' }}
          >
            {body}
          </p>
        </S.Body>
      )}
      place={place}
      preferPlace={preferPlace}
      theme={theme}
    >
      {React.cloneElement(
        children,
        triggerProps,
      )}
    </S.StyledPopover>
  );
};

Tooltip.defaultProps = {
  body: '',
  theme: 'dark',
  width: '150px',
  place: undefined,
  isOpen: undefined,
  children: null,
  toggleMode: false,
  initialState: false,
  preferPlace: 'below',
};

export default Tooltip;
